// import { ApolloClient, InMemoryCache } from '@apollo/client';
// import { setContext } from '@apollo/client/link/context/index.js';
// import { API_URL } from '../config.js';
// import { createUploadLink } from 'apollo-upload-client'; // ✅ fixed import

// const authLink = setContext((_, { headers }) => {
//   return {
//     headers: {
//       ...headers,
//       'x-token': localStorage.getItem('token') || '',
//     },
//   };
// });
// const uploadLink = createUploadLink({
//   uri: `${API_URL}/graphql`,
// });

// const client = new ApolloClient({
//   link: authLink.concat(uploadLink),
//   cache: new InMemoryCache(),
// });

// export default client;

import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "@apollo/client/link/context/index.js";
import { onError } from "@apollo/client/link/error/index.js";
import { API_URL } from "../config.js";

const safeFetch = (uri, options) => {
  const controller = new AbortController();
  const signal = controller.signal;

  const promise = fetch(uri, { ...options, signal }).catch((err) => {
    if (
      err?.name === "AbortError" ||
      err?.message?.includes("The user aborted a request")
    ) {
      // silently ignore abort
      return new Response(null, { status: 499, statusText: "Client Closed" });
    }
    throw err;
  });

  // Return promise but ignore if aborted
  return promise;
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      const message = err.message?.toLowerCase();

      if (
        message.includes("unauthorized") ||
        message.includes("token expired") ||
        message.includes("jwt expired") // ✅ handle backend error message
      ) {
        console.warn("🔒 JWT expired or unauthorized, logging out...");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/signup"; // or /login if that's your route
        return;
      }
    }
  }

  if (networkError) {
    if (
      networkError.name === "AbortError" ||
      networkError.message?.includes("The user aborted a request")
    )
      return;
    console.error("Apollo network error:", networkError);
  }
});



const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    "x-token": localStorage.getItem("token") || "",
  },
}));

const uploadLink = createUploadLink({
  uri: `${API_URL}/graphql`,
  fetch: safeFetch,
});

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, uploadLink]),
  cache: new InMemoryCache(),
});

// suppress React 18 unhandled rejection overlay
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason?.name === "AbortError" ||
    event.reason?.message?.includes("The user aborted a request")
  ) {
    event.preventDefault();
    console.debug("🛑 Ignored aborted request globally");
  }
});

export default client;
